import React from 'react';
import { MiniCheck, MiniNum } from './ControlPanelHelpers';

const EITopicsTab = ({ educatedIndividualFilters, setEducatedIndividualFilters, eiMinWords, setEiMinWords, minWordCount, setMinWordCount }) => (
  <div data-testid="cp-ei-panel">
    <div className="shimmer-text" style={{ fontSize: '0.52rem', marginBottom: 6, fontWeight: 600 }}>EDUCATED INDIVIDUAL SITES &middot; per-topic min words</div>
    {['science', 'engineering', 'construction', 'culinary', 'trades', 'mathematics', 'technology'].map(topic => (
      <div key={topic} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(253, 230, 138,0.05)' }}>
        <MiniCheck checked={educatedIndividualFilters[topic]} color="#38bdf8"
          onChange={() => setEducatedIndividualFilters(p => ({ ...p, [topic]: !p[topic] }))}
          label={topic.charAt(0).toUpperCase() + topic.slice(1)} />
        <MiniNum value={eiMinWords[topic] || 0}
          onChange={v => setEiMinWords(p => ({ ...p, [topic]: v }))} />
      </div>
    ))}
    <div style={{ marginTop: 6, borderTop: '1px solid rgba(253, 230, 138,0.1)', paddingTop: 5 }}>
      <MiniCheck checked={educatedIndividualFilters.favor_visuals} color="#22d3ee"
        onChange={() => setEducatedIndividualFilters(p => ({ ...p, favor_visuals: !p.favor_visuals }))}
        label="Favor Schematics/Diagrams/Drawings" />
      <MiniCheck checked={educatedIndividualFilters.favor_pictures} color="#38bdf8"
        onChange={() => setEducatedIndividualFilters(p => ({ ...p, favor_pictures: !p.favor_pictures }))}
        label="Favor Pictures/Photos/Illustrations" />
    </div>
    <div style={{ marginTop: 5, borderTop: '1px solid rgba(253, 230, 138,0.1)', paddingTop: 5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span style={{ color: '#555', fontSize: '0.52rem' }}>GLOBAL MIN WORDS</span>
      <MiniNum value={minWordCount} onChange={setMinWordCount} width={54} />
    </div>
  </div>
);

export default EITopicsTab;
